import { render } from "./CreateProjectModal.vue?vue&type=template&id=16958578&scoped=true"
import script from "./CreateProjectModal.vue?vue&type=script&lang=js"
export * from "./CreateProjectModal.vue?vue&type=script&lang=js"

import "./CreateProjectModal.vue?vue&type=style&index=0&id=16958578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16958578"]])

export default __exports__